import type { UnknownAction } from 'redux';

export type TourActions =
  | RequestInitializeTourAction
  | StartWelcomeTourAction
  | RequestStopWelcomeTourAction
  | StartNewFeatureTourAction
  | StopNewFeatureTourAction;

export interface RequestInitializeTourPayload {
  introductionTourSeen: boolean;
  seenFeatureIds: string[];
}

export interface RequestInitializeTourAction extends UnknownAction {
  payload: RequestInitializeTourPayload;
  type: 'TOUR:REQUEST_INITIALIZE';
}

export const requestInitializeTour = (
  payload: RequestInitializeTourPayload,
): RequestInitializeTourAction => ({
  payload,
  type: 'TOUR:REQUEST_INITIALIZE',
});

export interface StartWelcomeTourAction extends UnknownAction {
  payload: {};
  type: 'WELCOME_TOUR:START';
}

export const startWelcomeTour = (): StartWelcomeTourAction => ({
  payload: {},
  type: 'WELCOME_TOUR:START',
});

export interface RequestStopWelcomeTourAction extends UnknownAction {
  payload: {};
  type: 'WELCOME_TOUR:REQUEST_STOP';
}

export const requestStopWelcomeTour = (): RequestStopWelcomeTourAction => ({
  payload: {},
  type: 'WELCOME_TOUR:REQUEST_STOP',
});

export interface StartNewFeatureTourAction extends UnknownAction {
  payload: {
    ids: string[];
  };
  type: 'NEW_FEATURE_TOUR:START';
}

export const startNewFeatureTour = (ids: string[]): StartNewFeatureTourAction => ({
  payload: {
    ids,
  },
  type: 'NEW_FEATURE_TOUR:START',
});

export interface StopNewFeatureTourAction extends UnknownAction {
  payload: {
    seenIds: string[];
  };
  type: 'NEW_FEATURE_TOUR:STOP';
}

export const stopNewFeatureTour = (ids: string[]): StopNewFeatureTourAction => ({
  payload: {
    seenIds: ids,
  },
  type: 'NEW_FEATURE_TOUR:STOP',
});
